// component designed to render stacked bar chart with 3 input bar element with their respective colors
// sample data for chart is imported and commented

import React from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Label,
  Line,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";

export const StackBarWithoutYaxis = (props) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
        data={props.data}
      >
        <CartesianGrid strokeDasharray="3 3" />
        {props.isLegendRequired && (
          <Legend width="100%" verticalAlign="top" align="right" />
        )}

        <XAxis
          tickMargin={25}
          angle={-25}
          tick={{ fontSize: 14 }}
          stroke="black"
          dataKey={props.xAxisDataKey}
          axisLine={false}
        />

        <Tooltip
          formatter={function (value, name) {
            return `${value}`;
          }}
          labelFormatter={function (value) {
            return ``;
          }}
        />
        <Bar
          barSize={30}
          fontFamily="sans-serif"
          stackId="a"
          dataKey={props.barDataKey1}
          fill={props.bar1Color}
        ></Bar>
        <Bar
          barSize={30}
          stackId="a"
          dataKey={props.barDataKey2}
          fill={props.bar2Color}
        >
          {/* <LabelList dataKey={props.barDataKey2} position="center" /> */}
        </Bar>
        <Bar
          barSize={30}
          stackId="a"
          dataKey={props.barDataKey3}
          fill={props.bar3Color}
        >
          {/* <LabelList dataKey={props.barDataKey3} position="center" /> */}
        </Bar>
        <Bar
          barSize={30}
          stackId="a"
          dataKey={props.barDataKey4}
          fill={props.bar4Color}
        />
        <Bar
          barSize={30}
          stackId="a"
          dataKey={props.barDataKey5}
          fill={props.bar5Color}
        />
        <Bar
          barSize={30}
          stackId="a"
          dataKey={props.barDataKey6}
          fill={props.bar6Color}
        />

        {/* <LabelList dataKey={props.barDataKey4} position="center" /> */}
      </BarChart>
    </ResponsiveContainer>
  );
};

StackBarWithoutYaxis.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  xAxisDataKey: PropTypes.string.isRequired,
  barDataKey1: PropTypes.string.isRequired,
  barDataKey2: PropTypes.string.isRequired,
  barDataKey3: PropTypes.string.isRequired,
  bar1Color: PropTypes.string.isRequired,
  bar2Color: PropTypes.string.isRequired,
  bar3Color: PropTypes.string.isRequired,
  barDataKey4: PropTypes.string.isRequired,
  bar4Color: PropTypes.string.isRequired,
  barDataKey5: PropTypes.string.isRequired,
  barDataKey6: PropTypes.string.isRequired,
  bar6Color: PropTypes.string.isRequired,
  bar5Color: PropTypes.string.isRequired,
  isLegendRequired: PropTypes.bool.isRequired,
};

export default StackBarWithoutYaxis;
